import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import CustomDateRangePicker from '../../components/doctors/customDateRangePicker';
import Header from '../../components/doctors/partials/Header';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';
import ReactBarChart from '../../components/doctors/reactBarChart';
import ReactGraph from '../../components/doctors/reactGraph';
import ReactPieChart from '../../components/doctors/reactPieChart';
import { useGetRequest } from '../../hooks/useGetRequest';
import ReactLineChart from '../../components/doctors/ReactLineChart';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

function Home() {
  const [startDate, setStartDate] = useState(
    new Date(moment().subtract(7, 'days')).toISOString().split('T')[0],
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split('T')[0],
  );
  const [graphData, setGraphData] = useState([
    {
      name: moment().format('DD-MM-YY'),
      value: 0,
    },
  ]);
  const [patientsToday, setPatientsToday] = useState(0);
  const [patientsYesterday, setPatientsYesterday] = useState(0);
  const [patientsLast7Days, setPatientsLast7Days] = useState(0);
  const [patientsLast30Days, setPatientsLast30Days] = useState(0);
  const [appointmentsToday, setAppointmentsToday] = useState(0);
  const [appointmentsYesterday, setAppointmentsYesterday] = useState(0);
  const [appointmentsLast7Days, setAppointmentsLast7Days] = useState(0);
  const [appointmentsLast30Days, setAppointmentsLast30Days] = useState(0);
  const [totalPrescriptions, setTotalPrescriptions] = useState(0);
  const [totalPatient, setTotalPatient] = useState(0);
  const [prescriptionReport, setPrescriptionReport] = useState({});
  const [graphType, setGraphType] = useState('top_10_cheifComplains');
  const [genderWiseData, setGenderWiseData] = useState([
    { name: 'male', value: 0 },
    { name: 'female', value: 0 },
    { name: 'others', value: 0 },
  ]);
  const [ageWiseData, setAgeWiseData] = useState([
    { name: '0-15', value: 0 },
    { name: '15-30', value: 0 },
    { name: '30-45', value: 0 },
    { name: '45-60', value: 0 },
    { name: '>60', value: 0 },
  ]);

  const pieData = [
    { name: 'Completed', value: 75 },
    { name: 'Pending', value: 25 },
  ];

  const COLORS = ['#4F46E5', '#a3c538', '#1a9dff', '#f66424', '#fcc80a'];

  const calculateDays = () => {
    const start = moment(startDate);
    const end = moment(endDate);
    const diffDays = end.diff(start, 'days');

    return diffDays;
  };

  const { isLoading: isReportDataLoading, refetch: reportDataRefetch } =
    useGetRequest(
      'getReports',
      `doctors/reports?startDate=${startDate}&endDate=${endDate}`,
      (data) => {
        console.log('reportData: ', data);
        setGraphData(data.chartData.graphData);
        setGenderWiseData(data.chartData.genderData);
        setAgeWiseData(data.chartData.ageData);
        setAppointmentsToday(data.prescriptionsToday);
        setAppointmentsYesterday(data.prescriptionsYesterday);
        setAppointmentsLast7Days(data.prescriptionsLast7Days);
        setAppointmentsLast30Days(data.prescriptionsLast30Days);
        setPatientsToday(data.patientsToday);
        setPatientsYesterday(data.patientsYesterday);
        setPatientsLast7Days(data.patientsLast7Days);
        setPatientsLast30Days(data.patientsLast30Days);
        setTotalPatient(data.totalPatient);
        setTotalPrescriptions(data.totalPrescriptions);
      },
      (e) => {
        console.log('errormessage: ', e.message);
      },
    );

  const {
    isLoading: isPrescriptionReportDataLoading,
    refetch: prescriptionReportDataRefetch,
  } = useGetRequest(
    'getPrescriptionReports',
    `prescriptions/doctor-report?startDate=${startDate}&endDate=${endDate}`,
    (data) => {
      console.log('resp: ', data);
      setPrescriptionReport(data);
    },
    (e) => {
      console.log('errormessage: ', e.message);
    },
  );

  useEffect(() => {
    if (startDate && endDate) {
      reportDataRefetch();
      prescriptionReportDataRefetch();
    }
  }, [startDate, endDate]);

  // const graphData = [
  //   {
  //     name: "31-01-2023",
  //     value: 2400,
  //   },
  //   {
  //     name: "30-01-2023",
  //     value: 1398,
  //   },
  //   {
  //     name: "29-01-2023",
  //     value: 9800,
  //   },
  //   {
  //     name: "28-01-2023",
  //     value: 3908,
  //   },
  //   {
  //     name: "27-01-2023",
  //     value: 4800,
  //   },
  //   {
  //     name: "26-01-2023",
  //     value: 3800,
  //   },
  //   {
  //     name: "25-01-2023",
  //     value: 4300,
  //   },
  //   {
  //     name: "24-01-2023",
  //     value: 4300,
  //   },
  //   {
  //     name: "23-01-2023",
  //     value: 4300,
  //   },
  //   {
  //     name: "22-01-2023",
  //     value: 4300,
  //   },
  // ];

  // const genderWiseData = [
  //   { name: "male", value: 400 },
  //   { name: "female", value: 350 },
  //   { name: "others", value: 50 },
  // ];

  // const ageWiseData = [
  //   { name: "0-15", value: 200 },
  //   { name: "15-30", value: 250 },
  //   { name: "30-45", value: 280 },
  //   { name: "45-60", value: 180 },
  //   { name: ">60", value: 70 },
  // ];

  // const demoGraphicData = [
  //   { name: "urban", value: 400 },
  //   { name: "semi-urban", value: 300 },
  //   { name: "rural", value: 350 },
  //   { name: "n/a", value: 50 },
  // ];

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <div className="rx-body black" style={{ marginBottom: '5rem' }}>
          <Row>
            <Col md={8}>
              <div className="card card-body mt-3">
                <Row>
                  <Col md={4} sm={12}>
                    <div className="visit_report_title">
                      <p className="visit-patient-summary">
                        Patient and Visit Summary
                      </p>
                      <CustomDateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                      <h3 className="mt-2">{totalPrescriptions}</h3>
                      <p>Total Visits</p>
                      <h3>{totalPatient}</h3>
                      <p>Total Patients</p>
                      <hr style={{ width: '80%' }} />
                      <h3 className="mt-2" style={{ color: '#1a9dff' }}>
                        {'100'}
                      </h3>
                      <p>Visits</p>
                      <h3 style={{ color: '#1a9dff' }}>{'50'}</h3>
                      <p>Patients</p>
                    </div>
                  </Col>
                  <Col md={8} sm={12}>
                    <div>
                      <ReactGraph data={graphData} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={4}>
              <div className="card card-body mt-3">
                <div className="pie-chart-box">
                  <h5 className="mt-2">Patient Summary for Age</h5>
                  <ResponsiveContainer width="100%" height={326}>
                    <PieChart>
                      <Pie
                        data={ageWiseData}
                        cx="50%"
                        cy="50%"
                        innerRadius={70}
                        outerRadius={100}
                        paddingAngle={0}
                        dataKey="value"
                      >
                        {ageWiseData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                  <div className="text-center mt-3">
                    {ageWiseData.map((entry, index) => (
                      <>
                        <div
                          className="horizontal-bar"
                          style={{
                            backgroundColor: COLORS[index % COLORS.length],
                            color: 'white',
                            marginLeft: '1rem',
                          }}
                        >
                          <span>{entry.name}</span>
                        </div>
                        {entry.value}%
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="summary_block_container">
            <div className="statistics-block center color-today">
              <Row>
                <Col md={6}>
                  <i className="fa fa-users fa-5x stat-icon"></i>
                </Col>
                <Col md={6}>
                  <span className="stat-number">
                    <span
                      style={{
                        color: 'navajowhite',
                        fontSize: '1.2rem',
                      }}
                    >
                      {appointmentsToday}/
                    </span>
                    {patientsToday}
                  </span>
                  <span className="stat-time">Today</span>
                </Col>
              </Row>
            </div>
            <div className="statistics-block center color-yesterday">
              <Row>
                <Col md={6}>
                  <i className="fa fa-users fa-5x stat-icon"></i>
                </Col>
                <Col md={6}>
                  <span className="stat-number">
                    <span
                      style={{
                        color: 'navajowhite',
                        fontSize: '1.2rem',
                      }}
                    >
                      {appointmentsYesterday}/
                    </span>

                    {patientsYesterday}
                  </span>
                  <span className="stat-time">Yesterday</span>
                </Col>
              </Row>
            </div>
            <div className="statistics-block center color-last-7-days">
              <Row>
                <Col md={5}>
                  <i className="fa fa-users fa-5x stat-icon"></i>
                </Col>
                <Col md={7}>
                  <span className="stat-number">
                    <span
                      style={{
                        color: 'navajowhite',
                        fontSize: '1.2rem',
                      }}
                    >
                      {appointmentsLast7Days}/
                    </span>
                    {patientsLast7Days}
                  </span>
                  <span className="stat-time">Last 7 days</span>
                </Col>
              </Row>
            </div>
            <div className="statistics-block center color-last-30-days">
              <Row>
                <Col md={5}>
                  <i className="fa fa-users fa-5x stat-icon"></i>
                </Col>
                <Col md={7}>
                  <span className="stat-number">
                    <span
                      style={{
                        color: 'navajowhite',
                        fontSize: '1.2rem',
                      }}
                    >
                      {appointmentsLast30Days}/
                    </span>
                    {patientsLast30Days}
                  </span>
                  <span className="stat-time">Last 30 days</span>
                </Col>
              </Row>
            </div>
          </div>

          <Row>
            <Col md={6}>
              <div className="card card-body mt-3">
                <div className="patient_graph_organization">
                  <h5>Patient Graph for Organizations</h5>
                  <ReactLineChart
                    chartData={prescriptionReport?.organizationWisePatient}
                  />
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="card card-body mt-3" style={{ height: '97%' }}>
                {/* <select
                  name="graph_type"
                  className="select_graph_type"
                  onChange={(e) => setGraphType(e.target.value)}
                >
                  <option value={'top_10_cheifComplains'}>
                    Top 10 Chief Complains
                  </option>
                  <option value={'top_10_investigations'}>
                    Top 10 Investigations
                  </option>
                  <option value={'top_10_diagnoses'}>Top 10 Diagnoses</option>
                </select> */}

                <div className="justify-content-space-between-wrap">
                  <button
                    className="btn btn-small grapCchiefComplainBtn"
                    onClick={(e) => setGraphType('top_10_cheifComplains')}
                  >
                    Chief Complain
                  </button>
                  <button
                    className="btn btn-small graphinvestigationBtn"
                    onClick={(e) => setGraphType('top_10_investigations')}
                  >
                    Investigation
                  </button>
                  <button
                    className="btn btn-small graphdiagnosisBtn"
                    onClick={(e) => setGraphType('top_10_diagnoses')}
                  >
                    Diagnosis
                  </button>
                </div>

                <div className="patient_graph_organization">
                  {graphType === 'top_10_cheifComplains' && (
                    <>
                      <h5 style={{ color: 'black' }}>Top 10 Chief Complains</h5>
                      <ReactBarChart
                        chartData={prescriptionReport?.complainsData}
                        percent={0}
                      />
                    </>
                  )}
                  {/* {graphType === 'top_10_brandNames' && (
                    <>
                      <h5 style={{ color: 'black' }}>Top 10 BrandName</h5>
                      <ReactBarChart
                        chartData={prescriptionReport?.complainsData}
                        percent={0}
                      />
                    </>
                  )} */}
                  {graphType === 'top_10_investigations' && (
                    <>
                      <h5 style={{ color: 'black' }}>Top 10 Investigations</h5>
                      <ReactBarChart
                        chartData={prescriptionReport?.investigationsData}
                        percent={0}
                      />
                    </>
                  )}
                  {graphType === 'top_10_diagnoses' && (
                    <>
                      <h5 style={{ color: 'black' }}>Top 10 Diagnoses</h5>
                      <ReactBarChart
                        chartData={prescriptionReport?.diagnosesData}
                        percent={0}
                      />
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default Home;
